import React from 'react';

const SelectFileHeader = () => {
  return (
    <div className="selectFileHeader">
      <span className="demoHeaderText">
        1. Upload a picture of a tweet you want saved.
      </span>
    </div>
  );
};

export default SelectFileHeader;